export function parseNexudusErrorMessage(raw: string): string | null {
  const policyMatch = /^BREAKS_CANCELLATION_POLICY\|(\d+)$/.exec(raw);
  if (!policyMatch) return null;

  const minutes = parseInt(policyMatch[1], 10);
  const days = Math.floor(minutes / 1440);
  const hours = Math.floor((minutes % 1440) / 60);

  let period: string;
  if (days > 0) {
    period = `${days} day${days !== 1 ? 's' : ''}`;
  } else if (hours > 0) {
    period = `${hours} hour${hours !== 1 ? 's' : ''}`;
  } else {
    period = `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }

  return `This booking cannot be cancelled within ${period} of its start time.`;
}
